import { api } from "@/api/api";

export const Lecture = {
    state: {
        lectureList: [],
        applyLectureList: [],
        total: 0,
        applyTotal: 0,
    },
    getters: {
        getLectureList(state) {
            return state.lectureList;
        },
        getLectureTotalCount(state) {
            return state.total;
        },
        getApplyLectureList(state) {
            return state.applyLectureList;
        },
        getApplyLectureTotalCount(state) {
            return state.applyTotal;
        }
    },
    mutations: {
        setLectureList(state, payload) {
            state.lectureList = payload;
        },
        setLectureTotalCount(state, payload) {
            state.total = payload;
        },
        setApplyLectureList(state, payload) {
            state.applyLectureList = payload;
        },
        setApplyLectureTotalCount(state, payload) {
            state.applyTotal = payload;
        }
    },
    actions: {
        async getLectureList({ commit }, args) {
            await api.lecture
                .getLectureList(args)
                .then((res) => {
                    commit("setLectureList", res.data.lecture);
                    commit("setLectureTotalCount", res.data.total);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getLecture(_, id) {
            const response = await api.lecture.getLecture(id).catch((err) => {
                console.log(err);
                return Promise.reject(err.response.data.message);
            });
            return Promise.resolve(response.data);
        },

        async addLecture({ dispatch }, args) {
            await api.lecture
                .addLecture(args)
                .then(() => {
                    dispatch("getLectureList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updateLecture({ dispatch }, args) {
            await api.lecture
                .updateLecture(args)
                .then(() => {
                    dispatch("getLectureList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteLecture({ dispatch }, args) {
            await api.lecture
                .deleteLecture(args)
                .then(() => {
                    dispatch("getLectureList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteApplyLecture({ dispatch }, args) {
            await api.lecture
                .deleteApplyLecture(args.id)
                .then(() => {
                    dispatch("getApplyLectureList", args.param);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },


        async applyLecture(_, args) {
            await api.lecture
                .applyLecture(args)
                .then(() => {})
                .catch((err) => {
                    return Promise.reject(err);
                });
            return Promise.resolve();
        },

        async getApplyLectureList({ commit }, args) {
            await api.lecture
                .getApplyLectureList(args)
                .then((res) => {
                    commit("setApplyLectureList", res.data.applyLecture);
                    commit("setApplyLectureTotalCount", res.data.total)
                })
                .catch((err) => {
                    console.log(err);
                });
        },   
        
        async verifyPinLecture(_, args) {
            const response = await api.lecture
                .verifyPin(args)
                .catch((err) => {
                    console.log("err:", err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve(response.data);
        },
    },
};
